import {Injectable} from '@angular/core';
import {EventType, Router} from '@angular/router';
import {Observable, switchMap, TeardownLogic} from 'rxjs';
import {filter} from 'rxjs/operators';
import {ModalService} from '../modal';
import {LoadingIndicatorComponent} from './loading-indicator.component';

@Injectable()
export class RouteLoadingIndicatorService {

    public readonly loadingIndicator$ = this.createLoadingIndicator();

    private routeResolveStart$ = this.router.events.pipe(
        filter(event => event.type === EventType.NavigationStart)
    );

    private routeResolveEnd$ = this.router.events.pipe(
        filter(event => event.type === EventType.NavigationEnd)
    );

    constructor(
        private router: Router,
        private modalService: ModalService
    ) {}

    public listenToRouteLoading(): void {
        this.routeResolveStart$.pipe(
            switchMap(() => this.loadingIndicator$)
        ).subscribe();
    }

    private createLoadingIndicator(): Observable<any> {
        return new Observable((): TeardownLogic => {

            // [WEBTRADER-603] LoadingIndicatorComponent instead of RouteLoadingIndicatorComponent
            const loadingIndicator = this.modalService.open(LoadingIndicatorComponent, {
                destroyWhen: this.routeResolveEnd$
            });

            return () => loadingIndicator.destroy();
        });
    }

}
